import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Footer from './components/footer/footer';
import Navbar from './components/navbar/navbar';
import Modal from './components/modal/modal';

import Contact from './pages/contact';
import Login from './pages/login';
import Register from './pages/register';
import About from './pages/about';
import NoPage from './pages/nopage';
import Admin from './pages/admin';
import Events from './pages/events';
import GalleryPage from './pages/gallery-page';
import Listen from './pages/listen';
import News from './pages/news';

import Storage, { StorageContext } from './components/storage/storage-context';

import HttpService from './services/http.service';
import EventService from './services/event.service';
import StorageService from './services/storage.service';

import { defaultTheme, EventPerformance, Theme, deepMergeWithDefaults } from './models/models';

import config from './config/config';
import AdminUsers from './pages/admin/admin-users';
import AdminMedia from './pages/admin/admin-media';
import AdminTracks from './pages/admin/admin-tracks';
import AdminEvents from './pages/admin/admin-events';
import AdminReviews from './pages/admin/admin-reviews';
import AdminContacts from './pages/admin/admin-contacts';
import AdminTheme from './pages/admin/admin-theme';
import AdminNews from './pages/admin/admin-news';
import MailingList from './components/mailing-list/mailing-list';
import AdminMail from './pages/admin/admin-mail';
import Home from './pages/home';
import FontService from './services/font.service';

function App() {

  // console.log(process.env.NODE_ENV);
  // console.log(process.env.PUBLIC_URL);
  // console.log(process.env.TZ);

  const [storageContext, setStorageContext] = React.useContext(StorageContext);

  React.useEffect(() => {

    setStorageContext && (async () => {

      HttpService.get('theme').then(res => {

        // console.log('App.tsx useEffect HttpService.get(theme)', res);
        const stgObj = ({
          LOCAL: (() => JSON.parse(localStorage.getItem(config.APP_NAME) || '{}')),
          SESSION: (() => JSON.parse(sessionStorage.getItem(config.APP_NAME) || '{}')),
          COOKIE: (() => {}), // !!!!!TO DO
          WINDOW: (() => ((window as any)[config.APP_NAME]))
        })[config.AUTH_TOKEN_STORAGE_METHOD]();
        // console.log('stgObj', { ...stgObj });

        if (Object.keys(stgObj).length) {
          // console.log('App.tsx useEffect setStorageContext with stgObj');
          if (res.success && res.body) {
            // console.log('App.tsx useEffect setStorageContext with theme from server');
            const themeFromServer = deepMergeWithDefaults<Theme>(defaultTheme, res.body);
            // console.log('themeFromServer', themeFromServer);
            setStorageContext?.(sc => ({ ...sc, ...stgObj, theme: themeFromServer}));

          } else {
            // console.log('App.tsx useEffect setStorageContext with default theme');
            setStorageContext?.((sc: { [key: string]: any }) => ({ ...stgObj, theme: defaultTheme}));
          }
        }

      });

    })();

    EventService.resetEvents();
    
  }, []);

  React.useEffect(() => {
    if (storageContext?.theme) {
      FontService.loadFont((storageContext.theme as Theme).fonts.primary, 'font-primary');
      FontService.loadFont((storageContext.theme as Theme).fonts.secondary, 'font-secondary');
      FontService.loadFont((storageContext.theme as Theme).fonts.tertiary, 'font-tertiary');
    
      // setLinks(
      //   (storageContext.theme as Theme).content.links.split(/\s+/).map(l => l.trim()).filter(l => l.length).map(l => ({ 
      //     icon: appendClassNames((Icons.socials as any)[extractCoreDomain(l)] || Icons.link, 'h-7'),
      //     href: l,
      //     coreDomain: extractCoreDomain(l)
      //   }))
      // )
    }
  }, [storageContext]);

  return (
    <div className={`mx-auto min-h-screen font-primary`}>
      {/* storage has been mooved to highest level in index.tsx */}
      {/* <Storage keys={['token', 'user', 'events', 'eventsBusy', 'theme']}> */}
        <Modal>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
          {/* <BrowserRouter basename={`/iamzae`}> */}
          {/* <BrowserRouter> */}
            <Navbar
              css={{ 
                brand: 'gold-text font-tertiary', 
                container: `${(storageContext.theme as Theme)?.cards.tertiary || ''}`, //'shadow-lg border-1 bg-slate-700 text-emerald-400 p-1', // 'shadow-lg border-1 text-indigo-400 bg-orange-900',
                links: '',
              }}
              brand={`ZAETHEDEEJ`} //config.APP_NAME}
              links={[
                { title: 'home', href: '/home' },
                { title: 'events', href: '/events' },
                { title: 'news', href: '/news' }
              ]}
              menus={[
                {
                  title: 'about', submenu: [
                    { title: 'gallery', href: '/gallery' },
                    { title: 'listen', href: '/listen' },
                    { title: 'contact', href: '/contact' },
                    { title: 'about me', href: '/about' },
                  ] 
                },
                {
                  title: 'socials', submenu: [
                    { title: 'instagram', href: 'https://www.instagram.com/deejzae/' },
                    { title: 'soundcloud', href: 'https://soundcloud.com/zanae33' },
                  ]
                }
              ]}
            />
            <Routes>
              <Route path="/" element={<Home />}>
                <Route index element={<Home />} />
                <Route path="home" element={<Home />} />
              </Route>
              <Route path="contact" element={<Contact />} />
              <Route path="events" element={<Events />} />
              <Route path="events/:encodedEvent" element={<Events />} />
              <Route path="news" element={<News />}/>
              <Route path="listen" element={<Listen />} />
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
              <Route path="about" element={<About />} />
              <Route path="gallery" element={<GalleryPage />} />
              <Route path="nopage" element={<NoPage />} />
              <Route path="admin" element={<Admin />} />
              <Route path="admin/users" element={<AdminUsers/>} />
              <Route path="admin/media" element={<AdminMedia/>} />
              <Route path="admin/tracks" element={<AdminTracks/>} />
              <Route path="admin/events" element={<AdminEvents/>} />
              <Route path="admin/reviews" element={<AdminReviews/>} />
              <Route path="admin/reviews/:id" element={<AdminReviews/>} />
              <Route path="admin/contacts" element={<AdminContacts/>} />
              <Route path="admin/contacts/:id" element={<AdminContacts/>} />
              <Route path="admin/theme" element={<AdminTheme/>} />
              <Route path="admin/mail" element={<AdminMail/>} />
              <Route path="admin/news" element={<AdminNews/>} />
              <Route path="*" element={<NoPage />} />
            </Routes>
            <MailingList/>
            <Footer 
              links={[
                { title: 'home', href: '/home' },
                { title: 'events', href: '/events' },
                { title: 'news', href: '/news' },
                { title: 'contact', href: '/contact' },
                { title: 'about', href: '/about' },
              ]}
              socials={[
                { 
                  icon: (<svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 640 512"><path d="M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"/></svg>),
                  href: 'https://soundcloud.com/zanae33'
                },
                {
                  icon: (<svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>),
                  href: 'https://www.instagram.com/deejzae/'
                }
              ]}
            />
          </BrowserRouter>
        </Modal>
      {/* </Storage> */}
    </div>
  );
}

export default App;
